import axios from "axios";
import React, { useEffect, useState } from "react";
import FontAwesome from "react-fontawesome";
import { logo, serverUrl } from "../Utils/server";
import "./NavBar.css";
import ReactLoading from "react-loading";

function NavBar() {
  const [loading, setLoading] = useState(false);
  const [showNotices, setShowNotices] = useState(false);
  const [notices, setNotices] = useState([]);
  const [seen, setSeen] = useState(true);
  const ClickOutHandler = require("react-onclickout");

  const getNotices = () => {
    setLoading(true);
    const config = {
      method: "get",
      url: `${serverUrl}/notices`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.getItem("token")}`,
      },
    };

    axios(config).then((response) => {
      setSeen(response.data.seen);
      setNotices(response.data);
      setLoading(false);
    });
  };

  const updateSeen = () => {
    setLoading(true);
    const config = {
      method: "post",
      url: `${serverUrl}/notices/seen`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.getItem("token")}`,
      },
    };

    axios(config).then((response) => {
      setSeen(true);
      setLoading(false);
    });
  };

  useEffect(() => {
    getNotices();
  }, []);

  return (
    <div className="navbar">
      <div className="logo-container">
        <img src={logo} alt="Logo" />
        <p>Cgrum App</p>
      </div>
      <div className="right">
        <div
          className="icon-button"
          onClick={() => {
            updateSeen();
            setShowNotices(!showNotices);
          }}
        >
          {/* <FontAwesome name="bell" id="notice-icon">
            <div className="badgeicon" style={{ opacity: seen ? "0" : "1" }}></div>
          </FontAwesome> */}
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-bell-fill" viewBox="0 0 16 16">
  <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zm.995-14.901a1 1 0 1 0-1.99 0A5.002 5.002 0 0 0 3 6c0 1.098-.5 6-2 7h14c-1.5-1-2-5.902-2-7 0-2.42-1.72-4.44-4.005-4.901z"/>
</svg>
        </div>
        <div className="circle-avatar"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16">
  <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
</svg></div>
        <div className="column">
          <p>{localStorage.getItem("name")}</p>
          <p>{localStorage.getItem("email")}</p>
        </div>
      </div>
      {!showNotices ? (
        ""
      ) : (
        <ClickOutHandler
          onClickOut={() => {
            if (showNotices) {
              setShowNotices(false);
            }
          }}
        >
          <div
            className="notice-panel"
            style={
              loading || notices.notices?.length === 0
                ? {
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }
                : {}
            }
          >
            {loading ? (
              <center>
                <ReactLoading
                  type={"spinningBubbles"}
                  color={"var(--primaryColor)"}
                  width={"2rem"}
                  height={"2rem"}
                />
              </center>
            ) : notices.notices?.length === 0 ? (
              <center>No notices</center>
            ) : (
              notices.notices?.map((notice) => (
                <div className="notice">
                  <p>
                    <FontAwesome
                      name="bell"
                      style={{ fontSize: "1rem", marginRight: "0.5rem" }}
                    />
                    {notice.title}
                  </p>
                  <p>{notice.body}</p>
                  <div className="row">
                    <p>
                      {
                        notice.createdOn
                          .split("T")[1]
                          .split(".")[0]
                          .split(":")[0]
                      }
                      :
                      {
                        notice.createdOn
                          .split("T")[1]
                          .split(".")[0]
                          .split(":")[1]
                      }
                    </p>
                    <p>{notice.createdOn.split("T")[0]}</p>
                  </div>
                  <hr />
                </div>
              ))
            )}
          </div>
        </ClickOutHandler>
      )}
    </div>
  );
}

export default NavBar;
